module.exports = __webpack_public_path__ + "static/media/milan.ee5c2bc5.jpg";